import React, { FC } from 'react';

import { Box, Center, Flex, HStack, Stack } from '@chakra-ui/react';
import capitalize from 'lodash/capitalize';
import { useNavigate } from 'react-router-dom';
import { colorMap } from 'theme';

interface Props {
  critical: number;
  high: number;
  medium: number;
  low: number;
  category?: string;
}

export const AlertCount: FC<Props> = props => {
  const { critical, medium, low, high, category } = props;
  const navigate = useNavigate();

  const totalAlerts = (type: string, value: number) => (
    <Box h="full">
      <HStack
        fontSize="md"
        w="full"
        h="full"
        _hover={{ bg: colorMap.primary(50), cursor: 'pointer' }}
        px={2}
        py={2}
        borderRadius={6}
      >
        <Box bg={type} w={1} h="full" borderRadius={2} />
        <HStack
          justify={'space-between'}
          w="full"
          h="full"
          pl={3}
          onClick={() => {
            navigate(
              `/findings/overview?tab=${
                category ?? 'AllFindings'
              }&severity=${type?.toUpperCase()}&redirect=true`,
            );
          }}
        >
          <Flex minW={16} align="center" w="full" fontWeight={600}>
            {capitalize(type)}
          </Flex>
          <Center w="full">{value}</Center>
        </HStack>
      </HStack>
    </Box>
  );

  return (
    <Stack justify="space-between" h="full" spacing={0}>
      {totalAlerts('critical', critical)}
      {totalAlerts('high', high)}
      {totalAlerts('medium', medium)}
      {totalAlerts('low', low)}
    </Stack>
  );
};
